import moment from 'moment-timezone'

const schedule = {
  namespaced: true,
  state: {
    isLoaded: false,
    isLoading: false,
    shifts: [],
    shiftSwapRequestsLoaded: false,
    shiftSwapRequests: {
      createdRequests: [],
      assignedRequests: [],
      shiftRequests: [],
      openRequests: []
    },
    lastRefreshDate: moment().format('YYYY-MM-DD hh:mm:ss')
  },
  mutations: {
    loading (state) {
      state.isLoading = true
    },
    loadShifts (state, shifts) {
      state.shifts = shifts
      state.isLoaded = true
      state.isLoading = false
    },
    loadShiftSwapRequests (state, requests) {
      state.shiftSwapRequests.createdRequests = requests.created_requests
      state.shiftSwapRequests.assignedRequests = requests.assigned_requests
      state.shiftSwapRequests.shiftRequests = requests.shift_requests
      state.shiftSwapRequests.openRequests = requests.open_requests
      state.shiftSwapRequestsLoaded = true
    },
    clearSchedule (state) {
      state.isLoaded = false
      state.isLoaded = false
      state.isLoading = false
      state.shifts = []
      state.shiftSwapRequestsLoaded = false
      state.shiftSwapRequests = {
        createdRequests: [],
        assignedRequests: [],
        shiftRequests: [],
        openRequests: []
      }
      state.lastRefreshDate = moment().format('YYYY-MM-DD hh:mm:ss')
    }
  },
  getters: {
    nextShift: (state) => {
      return state.shifts.find(shift => {
        let start = moment.tz(moment(shift.day).utc().format('Y-MM-DD') + ' ' + shift.start_time, 'America/Los_Angeles')
        if (moment().isBefore(start)) {
          return true
        }
        return false
      })
    },
    nextShifts: (state) => {
      let nextShift = state.shifts.find(shift => {
        let start = moment.tz(moment(shift.day).utc().format('Y-MM-DD') + ' ' + shift.start_time, 'America/Los_Angeles').utc()
        if (moment().isBefore(start)) {
          return true
        }
        return false
      })
      if (nextShift !== undefined) {
        return state.shifts.filter(shift => {
          return shift.day === nextShift.day && shift.start_time === nextShift.start_time
        })
      } else return []
    },
    currentShifts: (state) => {
      return state.shifts.filter(shift => {
        let start = moment.tz(moment(shift.day).utc().format('Y-MM-DD') + ' ' + shift.start_time, 'America/Los_Angeles').utc()
        let end = moment.tz(moment(shift.day).utc().format('Y-MM-DD') + ' ' + shift.end_time, 'America/Los_Angeles').utc()
        if (moment().isAfter(start) && moment().isBefore(end)) {
          return true
        }
        return false
      })
    },
    isScheduled: (state) => {
      return state.shifts.length > 0
    },
    getShift: (state) => (id) => {
      return state.shifts.find(shift => {
        return shift.id === parseInt(id)
      })
    },
    hasCreatedRequests: (state) => {
      return state.shiftSwapRequests.createdRequests.length > 0
    },
    hasAssignedRequests: (state) => {
      return state.shiftSwapRequests.assignedRequests.length > 0
    },
    hasShiftRequests: (state) => {
      return state.shiftSwapRequests.shiftRequests.length > 0
    },
    hasOpenRequests: (state) => {
      return state.shiftSwapRequests.openRequests.length > 0
    },
    getQualifyingOpenRequests: (state, getters, rootState) => {
      return state.shiftSwapRequests.openRequests.filter(request => {
        // No requests made by this user
        let isCreator = request.student_volunteer.username === rootState.user.username

        // No requests for shifts that conflict
        let start = moment.tz(moment(request.shift.day).utc().format('Y-MM-DD') + ' ' + request.shift.start_time, 'America/Los_Angeles').utc()
        let end = moment.tz(moment(request.shift.day).utc().format('Y-MM-DD') + ' ' + request.shift.end_time, 'America/Los_Angeles').utc()
        let overlap = state.shifts.find(shift => {
          let shiftStart = moment.tz(moment(shift.day).utc().format('Y-MM-DD') + ' ' + shift.start_time, 'America/Los_Angeles').utc()
          let shiftEnd = moment.tz(moment(shift.day).utc().format('Y-MM-DD') + ' ' + shift.end_time, 'America/Los_Angeles').utc()
          if (start.isBefore(shiftStart) && end.isAfter(shiftStart)) {
            return true
          }
          if (start.isAfter(shiftStart) && start.isBefore(shiftEnd)) {
            return true
          }
          return false
        })

        // No shifts from the past
        let inPast = moment().isAfter(start)
        if (isCreator || overlap !== undefined || inPast) {
          return false
        }
        return true
      })
    },
    qualifyingShiftRequests: (state, getters, rootState) => {
      return state.shiftSwapRequests.shiftRequests.filter(request => {
        // No requests for shifts that conflict
        let start = moment.tz(moment(request.swapped_shift.day).utc().format('Y-MM-DD') + ' ' + request.swapped_shift.start_time, 'America/Los_Angeles').utc()
        let end = moment.tz(moment(request.swapped_shift.day).utc().format('Y-MM-DD') + ' ' + request.swapped_shift.end_time, 'America/Los_Angeles').utc()
        let overlap = state.shifts.find(shift => {
          let shiftStart = moment.tz(moment(shift.day).utc().format('Y-MM-DD') + ' ' + shift.start_time, 'America/Los_Angeles').utc()
          let shiftEnd = moment.tz(moment(shift.day).utc().format('Y-MM-DD') + ' ' + shift.end_time, 'America/Los_Angeles').utc()
          if (start.isBefore(shiftStart) && end.isAfter(shiftStart)) {
            return true
          }
          if (start.isAfter(shiftStart) && start.isBefore(shiftEnd)) {
            return true
          }
          return false
        })

        // No shifts from the past
        let inPast = moment().isAfter(start) || moment().isAfter(moment.tz(moment(request.shift.day).utc().format('Y-MM-DD') + ' ' + request.shift.start_time, 'America/Los_Angeles').utc())
        if (overlap !== undefined || inPast) {
          return false
        }
        return true
      })
    }
  },
  actions: {
    load ({commit, state, rootState}) {
      return new Promise((resolve, reject) => {
        commit('loading')
        if (rootState.user.isTeamLeader) {
          fetch(process.env.BASE_URL + 'schedule/tl/' + rootState.user.profile.id, {
            headers: {
              'Authorization': rootState.user.session.accessToken
            }
          }).then(response => {
            return response.json().then(payload => {
              if (payload.success) {
                commit('loadShifts', payload.data.shifts)
                resolve()
              } else {
                commit('error', payload.data, { root: true })
                resolve()
              }
            })
          }).catch((err) => {
            commit('error', { message: err.message }, { root: true })
            reject(err)
          })
        } else {
          fetch(process.env.BASE_URL + 'schedule/' + rootState.user.profile.id, {
            headers: {
              'Authorization': rootState.user.session.accessToken
            }
          }).then(response => {
            return response.json().then(payload => {
              if (payload.success) {
                commit('loadShifts', payload.data.shifts)
                resolve()
              } else {
                commit('error', payload.err, { root: true })
                resolve()
              }
            })
          }).catch((err) => {
            commit('error', { message: err.message }, { root: true })
            reject(err)
          })
        }
      })
    },
    savePerformanceRecords ({commit, rootState, dispatch}, records) {
      return new Promise((resolve, reject) => {
        // commit('savingPerformanceRecords')
        let performanceRecords = records.map(r => {
          return {
            id: r.id,
            shift_id: r.shift_id,
            student_volunteer_id: r.student_volunteer_id,
            check_in: r.check_in === null ? false : r.check_in,
            check_out: r.check_out === null ? false : r.check_out,
            rating: r.rating === null ? 0 : r.rating,
            notes: r.notes === null ? '' : r.notes
          }
        })
        console.log(performanceRecords)
        fetch(process.env.BASE_URL + 'schedule/pr', {
          method: 'POST',
          headers: {
            'Authorization': rootState.user.session.accessToken
          },
          body: JSON.stringify({performance_records: performanceRecords})
        }).then(response => {
          return response.json().then(payload => {
            if (payload.success) {
              dispatch('load').then(() => {
                resolve()
              })
            } else {
              console.log(payload)
              commit('error', payload.data, { root: true })
              resolve()
            }
          })
        }).catch((err) => {
          commit('error', { message: err.message }, { root: true })
          reject(err)
        })
      })
    },
    loadShiftSwapRequests ({ commit, rootState }) {
      return new Promise((resolve, reject) => {
        fetch(process.env.BASE_URL + 'schedule/swap/' + rootState.user.username, {
          headers: {
            'Authorization': rootState.user.session.accessToken.jwtToken
          }
        }).then(response => {
          return response.json().then(payload => {
            if (payload.success) {
              commit('loadShiftSwapRequests', payload.data)
              resolve()
            } else {
              commit('error', payload.data, { root: true })
              resolve()
            }
          })
        }).catch((err) => {
          commit('error', { message: err.message }, { root: true })
          reject(err)
        })
      })
    },
    getShiftsByDay ({ commit, rootState }, day) {
      return new Promise((resolve, reject) => {
        fetch(process.env.BASE_URL + 'schedule/shifts/' + day, {
          headers: {
            'Authorization': rootState.user.session.accessToken.jwtToken
          }
        }).then(response => {
          return response.json().then(payload => {
            if (payload.success) {
              resolve(payload.data.shifts)
            } else {
              commit('error', payload.data, { root: true })
              reject(payload.data)
            }
          })
        }).catch((err) => {
          commit('error', { message: err.message }, { root: true })
          reject(err)
        })
      })
    },
    createRequest ({ commit, rootState, dispatch }, request) {
      return new Promise((resolve, reject) => {
        request.svid = rootState.user.username
        fetch(process.env.BASE_URL + 'schedule/swap/create', {
          method: 'POST',
          headers: {
            'Authorization': rootState.user.session.accessToken.jwtToken
          },
          body: JSON.stringify(request)
        }).then(response => {
          return response.json().then(payload => {
            if (payload.success) {
              dispatch('loadShiftSwapRequests').then(() => {
                commit('message', { message: 'Successfully created shift swap request.' }, { root: true })
                resolve()
              })
            } else {
              commit('error', payload.data, { root: true })
              reject(payload.data)
            }
          })
        }).catch((err) => {
          commit('error', { message: err.message }, { root: true })
          reject(err)
        })
      })
    },
    acceptRequest ({ commit, rootState, dispatch }, request) {
      return new Promise((resolve, reject) => {
        request.svid = rootState.user.username
        fetch(process.env.BASE_URL + 'schedule/swap/accept', {
          method: 'POST',
          headers: {
            'Authorization': rootState.user.session.accessToken.jwtToken
          },
          body: JSON.stringify(request)
        }).then(response => {
          return response.json().then(payload => {
            if (payload.success) {
              dispatch('loadShiftSwapRequests').then(() => {
                dispatch('load').then(() => {
                  commit('message', { message: 'Successfully accepted shift swap request. Please check your schedule for updates.' }, { root: true })
                  resolve()
                })
              })
            } else {
              commit('error', payload.data, { root: true })
              reject(payload.data)
            }
          })
        }).catch((err) => {
          commit('error', { message: err.message }, { root: true })
          reject(err)
        })
      })
    },
    deleteRequest ({ commit, rootState, dispatch }, id) {
      console.log(id)
      return new Promise((resolve, reject) => {
        fetch(process.env.BASE_URL + 'schedule/swap/delete', {
          method: 'POST',
          headers: {
            'Authorization': rootState.user.session.accessToken.jwtToken
          },
          body: JSON.stringify({shift_swap_request_id: id})
        }).then(response => {
          return response.json().then(payload => {
            if (payload.success) {
              dispatch('loadShiftSwapRequests').then(() => {
                commit('message', { message: 'Successfully deleted shift swap request.' }, { root: true })
                resolve()
              })
            } else {
              commit('error', payload.data, { root: true })
              resolve()
            }
          })
        }).catch((err) => {
          commit('error', { message: err.message }, { root: true })
          reject(err)
        })
      })
    }
  }
}

export default schedule



// WEBPACK FOOTER //
// ./src/store/schedule.js